var _mask, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ticket_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0a3 3 0 11-6 0H3a3 3 0 00-3 3v16a3 3 0 003 3h20.17a3.001 3.001 0 015.66 0H33a3 3 0 003-3V3a3 3 0 00-3-3h-4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M29 0a3 3 0 11-6 0H3a3 3 0 00-3 3v16a3 3 0 003 3h20.17a3.001 3.001 0 015.66 0H33a3 3 0 003-3V3a3 3 0 00-3-3h-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0v-2h-2v2h2zm-6 0h2v-2h-2v2zm.17 22v2h1.415l.471-1.334L23.171 22zm5.66 0l-1.886.666.47 1.334h1.415v-2zM26 5a5 5 0 005-5h-4a1 1 0 01-1 1v4zm-5-5a5 5 0 005 5V1a1 1 0 01-1-1h-4zM3 2h20v-4H3v4zM2 3a1 1 0 011-1v-4a5 5 0 00-5 5h4zm0 16V3h-4v16h4zm1 1a1 1 0 01-1-1h-4a5 5 0 005 5v-4zm20.17 0H3v4h20.17v-4zm1.886 2.666c.139-.39.512-.666.944-.666v-4a5.001 5.001 0 00-4.715 3.334l3.771 1.332zM26 22c.432 0 .805.275.944.666l3.771-1.332A5.001 5.001 0 0026 18v4zm7-2h-4.17v4H33v-4zm1-1a1 1 0 01-1 1v4a5 5 0 005-5h-4zm0-16v16h4V3h-4zm-1-1a1 1 0 011 1h4a5 5 0 00-5-5v4zm-4 0h4v-4h-4v4z",
    fill: "currentColor",
    mask: "url(#ticket_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeDasharray: "2 2",
    d: "M26 5v13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M6 6h13M6 11h13M6 16h13"
  })));
}
export default SvgTicket;